export enum ITEM_TYPES {
    Dictionary = "dictionary",
    Chat = "chat",
    Leitner = "leitner",
    ParentItem = "parentItem",
    Quiz = "quiz",
    Idiom = "idiom",
    Partner = "partner",
    Puzzle = "puzzle",
    Document = "document",
    News = "news",
    Story = "story",
    Lesson = "lesson",
    ArtikelQuiz = "artikelQuiz",
    ImageQuiz = "imageQuiz",
    TranslationQuiz = "translationQuiz",
    InteractiveChatJourney = "interactiveChatJourney",
    AdsMessage = "adsMessage",
}

export enum DicLang {
    deFa = "deFa",
    faDe = "faDe",
    deEn = "deEn",
    enDe = "enDe",
    de = "de",
    fa = "fa",
    en = "en",
    ind = "ind",
    emir = "emir",
    turk = "turk",
    sweed = "sweed",
    spain = "spain",
    italy = "italy",
    fr = "fr",
}
// export function ITEM_TYPES_of(itemType:string):ITEM_TYPES {
//     let itemTypeEnum = "";
//     switch(itemType){
//         case ITEM_TYPES.Dictionary:
//             itemTypeEnum = ITEM_TYPES.Dictionary
//         case ITEM_TYPES.Chat:

//         case ITEM_TYPES.Leitner:

//         case ITEM_TYPES.Quiz:

//         case ITEM_TYPES.Idiom:

//         case ITEM_TYPES.Partner:

//         case ITEM_TYPES.Puzzle:

//         case ITEM_TYPES.Document:

//         case ITEM_TYPES.News:

//         case ITEM_TYPES.Story:

//         case ITEM_TYPES.Lesson:

//         case ITEM_TYPES.ArtikelQuiz:

//         case ITEM_TYPES.ImageQuiz:

//         case ITEM_TYPES.TranslationQuiz:

//         case ITEM_TYPES.AdsMessage:

//     }
//     return itemTypeEnum;
// } 